import React from "react";
import styles from "./RealStateHeader.module.scss";
//import Link from "next/link";
//import Image from "next/image";
import { RealStateHeaderProps } from "./RealStateHeader.interface";

export const RealStateHeader = (props: RealStateHeaderProps) => {
	const { cloudfrontUrl, baseUrl, realStateList } = props ?? {};
	return (
		<div className={`${styles.cMain} ${styles.realStateHeader}`}>
			{realStateList.map((img, index) => <a href={`${baseUrl}/${img.url}`} target='_blank' key={`img-${index}`}>
				<img
					src={`${cloudfrontUrl}${img.src}`}
					alt={img.name}
				/>
			</a>)}
		</div>
	);
};
